export const BRAZILIAN_UF_OPTIONS = [
  { label: "AC - Acre", value: "AC" },
  { label: "AL - Alagoas", value: "AL" },
  { label: "AP - Amapá", value: "AP" },
  { label: "AM - Amazonas", value: "AM" },
  { label: "BA - Bahia", value: "BA" },
  { label: "CE - Ceará", value: "CE" },
  { label: "DF - Distrito Federal", value: "DF" },
  { label: "ES - Espírito Santo", value: "ES" },
  { label: "GO - Goiás", value: "GO" },
  { label: "MA - Maranhão", value: "MA" },
  { label: "MT - Mato Grosso", value: "MT" },
  { label: "MS - Mato Grosso do Sul", value: "MS" },
  { label: "MG - Minas Gerais", value: "MG" },
  { label: "PA - Pará", value: "PA" },
  { label: "PB - Paraíba", value: "PB" },
  { label: "PR - Paraná", value: "PR" },
  { label: "PE - Pernambuco", value: "PE" },
  { label: "PI - Piauí", value: "PI" },
  { label: "RJ - Rio de Janeiro", value: "RJ" },
  { label: "RN - Rio Grande do Norte", value: "RN" },
  { label: "RS - Rio Grande do Sul", value: "RS" },
  { label: "RO - Rondônia", value: "RO" },
  { label: "RR - Roraima", value: "RR" },
  { label: "SC - Santa Catarina", value: "SC" },
  { label: "SP - São Paulo", value: "SP" },
  { label: "SE - Sergipe", value: "SE" },
  { label: "TO - Tocantins", value: "TO" },
];

export const EMPTY_CONTRACT_FILTERS = {
  customer_id: null,
  customer_cpf: null,
  customer_state: null,
  bank_id: null,
  status: null,
  category: null,
  state: null,
  contract_type_id: null,
  lawyer_id: null,
  lawyer_wallet_id: null,
  sales_consultant_id: null,
  responsible_user_id: null,
  number: null,
  process_number: null,
  date_start: null,
  date_end: null,
  filed_at_start: null,
  filed_at_end: null,
  file_at_start: null,
  file_at_end: null,
  deleted_at_start: null,
  deleted_at_end: null,
  deleted_by_id: null,
  has_ajg: null,
  has_after_sales_video: null,
  is_rate_below_abusive_threshold: null,
  declares_irpf: null,
  customer_documents_update_status: null,
  customer_documents_last_updated_at_from: null,
  customer_documents_last_updated_at_to: null,
};

export const DEFAULT_CONTRACTS_LIST_SNAPSHOT = {
  search_term: "",
  imported_status_filter: "all",
  missing_data_filter: "all",
  show_deleted_contracts: false,
};

export const CONTRACTS_FILTER_CONTEXT = "contracts";

const normalizeFilterValue = (value) => {
  if (value === undefined || value === null || value === "") {
    return null;
  }
  if (Array.isArray(value)) {
    const joined = value.map((item) => String(item).trim()).filter(Boolean).join(",");
    return joined || null;
  }
  return value;
};

/** Converte valor de filtro multi-select (string CSV ou array) em lista. */
export const parseMultiFilterValue = (value) => {
  if (value === undefined || value === null || value === "") {
    return [];
  }
  const raw = Array.isArray(value) ? value.join(",") : String(value);
  return raw
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

/** Serializa lista de valores para armazenamento/envio do filtro. */
export const formatMultiFilterValue = (values) => {
  if (!values?.length) {
    return null;
  }
  return values.map((item) => String(item).trim()).filter(Boolean).join(",");
};

/** Garante todos os campos avançados, limpando os que não existem no snapshot salvo. */
export const normalizeAdvancedFilters = (raw = {}) => {
  const normalized = {};
  Object.keys(EMPTY_CONTRACT_FILTERS).forEach((key) => {
    normalized[key] = normalizeFilterValue(raw[key]);
  });
  return normalized;
};

export const buildContractFiltersSnapshot = ({
  filters,
  searchTerm = "",
  importedStatusFilter = "all",
  missingDataFilter = "all",
  showDeletedContracts = false,
}) => ({
  filters: normalizeAdvancedFilters(filters),
  search_term: searchTerm || "",
  imported_status_filter: importedStatusFilter || "all",
  missing_data_filter: missingDataFilter || "all",
  show_deleted_contracts: !!showDeletedContracts,
});

export const parseContractFiltersSnapshot = (filtersData = {}) => {
  const data =
    filtersData && typeof filtersData === "object" && !Array.isArray(filtersData)
      ? filtersData
      : {};

  const rawAdvanced =
    data.filters && typeof data.filters === "object" && !Array.isArray(data.filters)
      ? data.filters
      : {};

  return {
    filters: normalizeAdvancedFilters(rawAdvanced),
    searchTerm:
      data.search_term !== undefined && data.search_term !== null
        ? String(data.search_term)
        : DEFAULT_CONTRACTS_LIST_SNAPSHOT.search_term,
    importedStatusFilter:
      data.imported_status_filter || DEFAULT_CONTRACTS_LIST_SNAPSHOT.imported_status_filter,
    missingDataFilter:
      data.missing_data_filter || DEFAULT_CONTRACTS_LIST_SNAPSHOT.missing_data_filter,
    showDeletedContracts:
      data.show_deleted_contracts !== undefined
        ? Boolean(data.show_deleted_contracts)
        : DEFAULT_CONTRACTS_LIST_SNAPSHOT.show_deleted_contracts,
  };
};

export const buildEmptyContractFiltersSnapshot = () =>
  buildContractFiltersSnapshot({
    filters: EMPTY_CONTRACT_FILTERS,
    searchTerm: DEFAULT_CONTRACTS_LIST_SNAPSHOT.search_term,
    importedStatusFilter: DEFAULT_CONTRACTS_LIST_SNAPSHOT.imported_status_filter,
    missingDataFilter: DEFAULT_CONTRACTS_LIST_SNAPSHOT.missing_data_filter,
    showDeletedContracts: DEFAULT_CONTRACTS_LIST_SNAPSHOT.show_deleted_contracts,
  });
